import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;

function AcceptApproval() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = searchParams.get("token");
    const productType = "Hotel";

    if (!token) {
      setMessage("Invalid approval link.");
      setLoading(false);
      return;
    }

    fetch(`${REACT_APP_API}/api/Organization/Approval/AcceptHotelApproval?token=${token}&productType=${productType}`)
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text);
        }
        return res.json();
      })
      .then((data) => {
        //console.log(data);
        setMessage(data.message);
        if(data.success ==true && data?.data?.referenceNo){
          //console.log("data", data);
          navigate(`/hotel/thankyou?ReferenceNo=${data.data.referenceNo}`);
        }
      })
      .catch(() => {
        setMessage("Invalid or expired approval link.");
      })
      .finally(() => {
        setLoading(false);
      });

  }, [searchParams]);

  return (
    <>
      

      <div>
        <div className="container">
          <div className="box_shadow mt-5 text-center">
            <div className="col-md-12">
             {loading ? (
          <div>
            <div className="loader"></div>
            <p>Processing request...</p>
          </div>
        ) : (
          <h2 style={{ color: "#ff0000" }}>{message}</h2>
        )}
            </div>
            </div>
            </div>
       
      </div>
    </>
  );
}

export default AcceptApproval;